import { render, staticRenderFns } from "./rewardOnePlusSixCollectEdit.vue?vue&type=template&id=5387463d&scoped=true&"
import script from "./rewardOnePlusSixCollectEdit.vue?vue&type=script&lang=js&"
export * from "./rewardOnePlusSixCollectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387463d",
  null
  
)

export default component.exports